import { createSlice } from '@reduxjs/toolkit'

import { clientApi } from 'src/api/clientApi'

const initialState = {
  data: undefined,
  isLoaded: false,
}

const slice = createSlice({
  name: 'subscription_info',
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
      state.isLoaded = true
    }
  }
})

export const load = () => async (dispatch) => {
  try {
    const data = await clientApi.fetchSubscriptionInfo()
    dispatch(slice.actions.setData(data))
    return data
  } catch (e) {
    console.error(e)
  }
}

export default {
  slice,
  load,
}
